/* Move the existing nutrition section ahead of long description/reviews.
   No duplication or rewriting of nutrition data. All original IDs survive. */
(()=>{
  function arrange(){
    document.querySelectorAll('[data-nv-conversion-root]').forEach(root=>{
      const position=root.querySelector('[data-nv-nutrition-position]');
      if(!position||position.children.length)return;
      const wrapper=root.closest('.shopify-section');
      let next=wrapper?.nextElementSibling;
      if(next?.id.includes('nv_nutrition_facts'))position.append(next);
      else root.querySelector('[data-nv-nutrition-link]')?.setAttribute('hidden','');
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',arrange,{once:true});else arrange();
  document.addEventListener('shopify:section:load',arrange);
})();
